"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setResponsePipeDecorator = exports.setResponseDataDecorator = exports.setResponseComposeDecorator = exports.setRequestLogDecorator = exports.setRequestHeaderDecorator = exports.setRequestConfigDecorator = exports.setExtraExtensionParameterDecorator = exports.setDelayDecorator = exports.getPromptDecorator = exports.getMockDecorator = exports.getMessageDecorator = exports.getLoadingDecorator = exports.getConfirmDecorator = exports.getCacheDecorator = exports.getCacheDataDecorator = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _core = require("../core");
var _utils = require("../utils");
var _constant = require("../constant");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var NODE_ENV = process.env.NODE_ENV; // loading decorator

var getLoadingDecorator = function getLoadingDecorator(show, hide) {
  return (0, _core.createDecorator)(function (fn) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var res,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (show && hide) {
                show();
              }
              res = fn.apply(void 0, _args);
              if (!(typeof res === 'function')) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", res()["finally"](hide));
            case 4:
              _context.next = 6;
              return res["finally"](hide);
            case 6:
              return _context.abrupt("return", _context.sent);
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  });
}; // success or error message notify

exports.getLoadingDecorator = getLoadingDecorator;
var getMessageDecorator = function getMessageDecorator(toast) {
  return function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      successMsg = _ref2.successMsg,
      errorMsg = _ref2.errorMsg,
      msgKey = _ref2.msgKey;
    var alert = typeof window !== 'undefined' ? window.alert : console.log;
    var getToast = function getToast(key) {
      return (0, _typeof2["default"])(toast) === 'object' && typeof toast[key] === 'function' ? toast[key] : alert;
    };
    var successToast = getToast('success');
    var errorToast = getToast('error');
    return (0, _core.createDecorator)(function (fn) {
      return function () {
        var middleFn = fn.apply(void 0, arguments);
        var request = middleFn.then ? middleFn : middleFn();
        return typeof fn === 'function' && request.then(function (res) {
          var msg = msgKey ? res[msgKey] : successMsg;
          msg && successToast(msgKey ? res[msgKey] : successMsg);
          return Promise.resolve(res);
        }, function (err) {
          var msg = msgKey ? err[msgKey] : errorMsg;
          msg && errorToast(msgKey ? err[msgKey] : errorMsg);
          return Promise.reject(err);
        });
      };
    });
  };
}; // request log

exports.getMessageDecorator = getMessageDecorator;
var setRequestLogDecorator = (0, _core.createDecorator)(function (fn) {
  return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _console;
    var name,
      _len,
      args,
      _key,
      result,
      _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            name = fn ? fn.name : 'anonymity';
            for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args2[_key];
            }
            (_console = console).log.apply(_console, ["[log] ".concat(name, " before: ")].concat(args));
            _context2.next = 5;
            return fn.apply(void 0, args);
          case 5:
            result = _context2.sent;
            console.log("[log] ".concat(name, " after: "), result);
            return _context2.abrupt("return", result);
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}); // mock decorator

exports.setRequestLogDecorator = setRequestLogDecorator;
var getMockDecorator = function getMockDecorator(mock) {
  return function () {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constant.DEVELOPMENT;
    return (0, _core.createDecorator)(function (fn) {
      return function () {
        var res = env === NODE_ENV ? mock.apply(void 0, arguments) : fn.apply(void 0, arguments);
        return typeof res === 'function' ? res() : res;
      };
    });
  };
}; // set request header config

exports.getMockDecorator = getMockDecorator;
var setRequestHeaderDecorator = function setRequestHeaderDecorator() {
  for (var _len2 = arguments.length, headers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    headers[_key2] = arguments[_key2];
  }
  return (0, _core.createDecorator)(function (fn) {
    return function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var params = [].concat(args, [{
        headers: headers
      }]);
      var res = fn.apply(void 0, (0, _toConsumableArray2["default"])(params));
      return typeof res === 'function' ? res.apply(void 0, (0, _toConsumableArray2["default"])(params)) : res;
    };
  });
}; // set request config

exports.setRequestHeaderDecorator = setRequestHeaderDecorator;
var setRequestConfigDecorator = function setRequestConfigDecorator() {
  for (var _len4 = arguments.length, config = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    config[_key4] = arguments[_key4];
  }
  return (0, _core.createDecorator)(function (fn) {
    return function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      var params = [].concat(args, [{
        config: config
      }]);
      var res = fn.apply(void 0, (0, _toConsumableArray2["default"])(params));
      return typeof res === 'function' ? res.apply(void 0, (0, _toConsumableArray2["default"])(params)) : res;
    };
  });
}; // set request delay

exports.setRequestConfigDecorator = setRequestConfigDecorator;
var setDelayDecorator = function setDelayDecorator() {
  var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0, _core.createDecorator)(function (fn) {
    return function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      if (NODE_ENV === _constant.DEVELOPMENT) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            var res = fn.apply(void 0, args);
            resolve(typeof res === 'function' ? res() : res);
          }, wait);
        });
      }
      var res = fn.apply(void 0, args);
      return typeof res === 'function' ? res() : res;
    };
  });
}; // set response transform to target data

exports.setDelayDecorator = setDelayDecorator;
var setResponseDataDecorator = function setResponseDataDecorator(handle) {
  return (0, _core.createDecorator)(function (fn) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var data,
        res,
        _args3 = arguments;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fn.apply(void 0, _args3);
            case 2:
              data = _context3.sent;
              if (!(typeof data === 'function')) {
                _context3.next = 8;
                break;
              }
              _context3.next = 6;
              return data();
            case 6:
              res = _context3.sent;
              return _context3.abrupt("return", handle(res));
            case 8:
              return _context3.abrupt("return", handle(data));
            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  });
}; // del confirm decorator

exports.setResponseDataDecorator = setResponseDataDecorator;
var getConfirmDecorator = function getConfirmDecorator() {
  for (var _len7 = arguments.length, config = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    config[_key7] = arguments[_key7];
  }
  return function (handle) {
    return (0, _core.createDecorator)(function (fn) {
      return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var confirm,
          res,
          _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return handle.apply(void 0, config);
              case 2:
                confirm = _context4.sent;
                if (!confirm) {
                  _context4.next = 6;
                  break;
                }
                res = fn.apply(void 0, _args4);
                return _context4.abrupt("return", typeof res === 'function' ? res() : res);
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    });
  };
}; // set additional extension parameters

exports.getConfirmDecorator = getConfirmDecorator;
var setExtraExtensionParameterDecorator = function setExtraExtensionParameterDecorator() {
  for (var _len8 = arguments.length, extras = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    extras[_key8] = arguments[_key8];
  }
  return (0, _core.createDecorator)(function (fn) {
    return function () {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }
      var params = [].concat(args, [{
        extras: extras
      }]);
      var res = fn.apply(void 0, (0, _toConsumableArray2["default"])(params));
      return typeof res === 'function' ? res.apply(void 0, (0, _toConsumableArray2["default"])(params)) : res;
    };
  });
}; // set input prompt tips

exports.setExtraExtensionParameterDecorator = setExtraExtensionParameterDecorator;
var getPromptDecorator = function getPromptDecorator() {
  for (var _len10 = arguments.length, config = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    config[_key10] = arguments[_key10];
  }
  return function (handle, key) {
    return (0, _core.createDecorator)(function (fn) {
      return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var confirm,
          value,
          _len11,
          args,
          _key11,
          res,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return handle.apply(void 0, config);
              case 2:
                confirm = _context5.sent;
                if (!confirm) {
                  _context5.next = 11;
                  break;
                }
                value = confirm.value;
                for (_len11 = _args5.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
                  args[_key11] = _args5[_key11];
                }
                args[0] = _objectSpread(_objectSpread({}, args[0]), {}, (0, _defineProperty2["default"])({}, key, value));
                _context5.next = 9;
                return fn.apply(void 0, args);
              case 9:
                res = _context5.sent;
                return _context5.abrupt("return", typeof res === 'function' ? res() : res);
              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    });
  };
}; // set response data compose pipe line

exports.getPromptDecorator = getPromptDecorator;
var composeOrPipe = function composeOrPipe() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constant.COMPOSE;
  return function () {
    for (var _len12 = arguments.length, handle = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      handle[_key12] = arguments[_key12];
    }
    return (0, _core.createDecorator)(function (fn) {
      return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var data,
          res,
          _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fn.apply(void 0, _args6);
              case 2:
                data = _context6.sent;
                if (!(typeof data === 'function')) {
                  _context6.next = 7;
                  break;
                }
                _context6.next = 6;
                return data();
              case 6:
                data = _context6.sent;
              case 7:
                res = function res(_) {
                  return _;
                };
                if (key === _constant.COMPOSE) {
                  res = _utils.compose.apply(void 0, handle);
                } else if (key === _constant.PIPE) {
                  res = _utils.pipe.apply(void 0, handle);
                }
                return _context6.abrupt("return", res(data));
              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    });
  };
};
var setResponseComposeDecorator = composeOrPipe(_constant.COMPOSE);
exports.setResponseComposeDecorator = setResponseComposeDecorator;
var setResponsePipeDecorator = composeOrPipe(_constant.PIPE); // get cache

exports.setResponsePipeDecorator = setResponsePipeDecorator;
var getCacheDecorator = function getCacheDecorator(handle) {
  return (0, _core.createDecorator)(function (fn) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
      var cache,
        res,
        _args7 = arguments;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              cache = handle();
              if (!cache) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return", cache);
            case 5:
              _context7.next = 7;
              return fn.apply(void 0, _args7);
            case 7:
              res = _context7.sent;
              return _context7.abrupt("return", typeof res === 'function' ? res() : res);
            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  });
}; // cache

exports.getCacheDecorator = getCacheDecorator;
var getCacheDataDecorator = function getCacheDataDecorator(set, get) {
  return function (key) {
    return (0, _core.createDecorator)(function (fn) {
      return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var uniqueKey,
          cache,
          data,
          res,
          _args8 = arguments;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                uniqueKey = key + JSON.stringify(_args8.length <= 0 ? undefined : _args8[0]);
                cache = get(_objectSpread({
                  key: uniqueKey
                }, _args8.length <= 0 ? undefined : _args8[0]));
                if (!cache) {
                  _context8.next = 6;
                  break;
                }
                return _context8.abrupt("return", cache);
              case 6:
                _context8.next = 8;
                return fn.apply(void 0, _args8);
              case 8:
                data = _context8.sent;
                res = typeof data === 'function' ? data() : data;
                return _context8.abrupt("return", set(_objectSpread({
                  key: uniqueKey
                }, res)));
              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    });
  };
};
exports.getCacheDataDecorator = getCacheDataDecorator;